import Cookies from 'js-cookie'

// 屏幕分辨率宽度是否低于1366
const isLowerThenScreen1366 = (function() {
  const screen1366Width = 1366 / window.devicePixelRatio // 适配1366*768分辨率的屏幕宽度(px)
  const offsetPx = window.screen.width - screen1366Width // 与当前屏幕的偏移量
  return offsetPx <= 10 // 10为误差值
}())

const state = {
  sidebar: {
    // opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    opened: true,
    withoutAnimation: false
  },
  device: 'desktop',
  language: Cookies.get('language') || 'zh',
  size: Cookies.get('size') || 'mini',
  canCloseModule: true,
  showedOweRemind: false, // 是否显示过了欠费通知
  isLowerThenScreen1366,
  canCloseModuleMap: new Set()
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_CAN_CLOSE_MODULE: (state, canCloseModule) => {
    state.canCloseModule = canCloseModule
  },
  SET_SHOWED_OWEREMIND: (state, showedOweRemind) => {
    state.showedOweRemind = showedOweRemind
  },
  TOGGLE_IE_TIP: (state, flag) => {
    state.shouldShowIeTip = flag
  },
  SET_CAN_CLOSE_MODULE_MAP: (state, canCloseModuleMap) => {
    state.canCloseModuleMap = canCloseModuleMap
  }
}

const actions = {
  toggleIeTip({ commit }, flag) {
    commit('TOGGLE_IE_TIP', flag)
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation = false } = {}) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setCanCloseModule({ commit }, canCloseModule) {
    commit('SET_CAN_CLOSE_MODULE', canCloseModule)
  },
  setShowedOweRemind({ commit }, showedOweRemind) {
    commit('SET_SHOWED_OWEREMIND', showedOweRemind)
  },
  setCanCloseModuleMap({ commit }, canCloseModuleMap) {
    commit('SET_CAN_CLOSE_MODULE_MAP', canCloseModuleMap)
  },
  cancelModalDialog() {
    // 取消模态对话框
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
